export default "__VITE_ASSET__BmRXzo82__"